export enum Themes {
  WHITELABEL = 'whitelabel',
  NONE = 'none',
}

export function setTheme(theme: Themes) {
  document.body.setAttribute('theme', theme);
}
